/**
 * One row of the import banner (REV-22527): the accounting data, or the documents from SharePoint.
 *
 * The container has already turned the server's steps into a label and a sentence. This view holds no
 * vocabulary of its own.
 */
export interface ClosingImportRow {
    /** Stable identity for `trackBy`, so a re-poll does not re-create the rows. */
    readonly key: string;
    readonly label: string;
    /** The line under the label once the row is done («2024 und 2023 geladen»), or `null`. */
    readonly detail: string | null;
    readonly status: ClosingImportRowStatus;
}

export type ClosingImportRowStatus = 'pending' | 'running' | 'done' | 'failed';

/** Where the whole import stands: running, done (shown briefly), or stopped by a failed row. */
export type ClosingImportState = 'running' | 'done' | 'failed';
